import { Col, Layout, Row, Space, Typography } from "antd";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../context/themeContext";
import CustomHeader from "../components/common/Header";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../constants/Route";
import {LOGO_SVG_URL } from "../constants/common";

const { Title } = Typography;
const ProviderPortal = () => {
  const { theme } = useContext(ThemeContext);
  const { Content, Footer } = Layout;
  const { t } = useTranslation();

  return (
    <Layout className="bg-white">
      <CustomHeader />
      <Content className="p-4 pb-0 md:p-6">
        <div className="container mx-auto">
          <Row gutter={[10, 30]}>
            <Col span={24}>
              <Space direction="vertical" className="welcome-block" size={0}>
                <Title level={4} className="text-black welcome-line">
                  {" "}
                  {t("common:welcome_brand_portal")}
                </Title>
                <Title level={4} className="text-black welcome-sub-line">
                  {/* <Badge color="black" />{" "} */}
                  <span>{t("common:welcome_sub_line")}</span>
                </Title>
              </Space>
            </Col>
            <Col span={24}>
              <Row gutter={[0, 0]}>
                <Space
                  size={10}
                  align="baseline"
                  className={`tabs-container  w-full px-1 md:px-5 ${
                    sessionStorage.getItem("IsFMLAEnabled").toLowerCase() ===
                    "true"
                      ? "justify-around"
                      : "justify-center"
                  }`}
                >
                  <div className="tabs-wrapper m-0">
                    <Link to={ROUTES.WELCOME} className={`tabs-item ${theme}`}>
                      <Title level={2} className="text-white font-bold">
                        {t("common:medical_records")}
                      </Title>
                    </Link>
                    <p className="mt-3 ps-1 !text-center md:!text-left">
                      {t("common:medical_records_description")}
                    </p>
                  </div>
                  {sessionStorage.getItem("IsFMLAEnabled").toLowerCase() ===
                    "true" && (
                    <div className="tabs-wrapper m-0">
                      <Link to={ROUTES.REQUIREMENT} className={`tabs-item ${theme}`}>
                        <Title level={2} className="text-white font-bold">
                          {t("common:fmla_disability")}
                        </Title>
                      </Link>
                      <p className="mt-3 ps-1 !text-center md:!text-left">
                        {t("common:fmla_disability_description")}
                      </p>
                    </div>
                  )}
                </Space>
              </Row>
            </Col>
            <Col span={24} align="center">
              <Space direction="vertical" className="or-information">
                <Space direction="vertical" size={0} style={{ width: "100%" }}>
                  <Title
                    level={4}
                    className="text-black font-normal information-sub-line"
                  >
                    <div className="px-4 mt-[40px]">
                      {/* <Badge color="#000000" /> */}
                      <span>
                        {t("common:if_you_have")}{" "}
                        <u className="font-bold">{t("common:all")}</u>{" "}
                        {t("common:all_required_documents")}{" "}
                        <u className="font-bold">{t("common:email")}</u>{" "}
                        {t("common:us_at")}
                      </span>
                      <a
                        className={`font-bold link ${theme}`}
                        href="mailto:requests@provider1st.com"
                      >
                        {" "}
                        {t("common:req_provider_email")}
                      </a>{" "}
                      {t("common:or")}{" "}
                      <u className="font-bold">{t("common:fax")}</u>{" "}
                      {t("common:us_at")}
                      <u className={`${theme}-color font-bold`}>
                        {" "}
                        {t("common:phone_number_dial")}
                      </u>{" "}
                      {t("common:and")} <u>{t("common:skip")}</u>{" "}
                      {t("common:the_online_process")}
                    </div>
                  </Title>
                </Space>
              </Space>
            </Col>
          </Row>
          <Footer className="welcome-footer bg-white p-3 pl-0 md:pl-9">
            <Row>
              <Col span={24}>
                <Title
                  level={2}
                  align="center"
                  className="mt-[50px] !font-[600]"
                >
                  {t(
                    "common:if_you_need_assistance_with_your_request_please_give_us_a_call"
                  )}
                  <u className={`${theme}-color ml-1`}>
                    {t("common:help_phone_number")}
                  </u>
                  .
                </Title>
              </Col>
            </Row>
          </Footer>
          <Row>
            <Col span={24} className="text-right">
              <Space direction="vertical" className="text-left" size={0}>
                <span className="font-medium">{t("common:powered_by")}</span>
                <img
                  alt="Provider1st Logo"
                  src={window.location.origin + LOGO_SVG_URL}
                />
              </Space>
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default ProviderPortal;
